<template>
  <div>
    <div class="corpo-pagina">
      <div class="row row-text">
        <div class="col s1"></div>
        <div class="col s10 content-container">

          <h4>Dettagli Stanza (Tutti i Record)</h4>

          <div class="row">
            <div class="col s12 right-align">
              <button
                class="btn waves-effect waves-light blue darken-1"
                @click="goToCreateRoom"
              >
                Crea Nuova Stanza
                <i class="material-icons right">add</i>
              </button>
            </div>
          </div>

          <hr class="separator"/> <div v-if="roomData && roomData.length > 0">
            <table class="striped">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Descrizione</th>
                  <th>Colore</th>
                  <th>Immagine</th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="room in roomData" :key="room.uid">
                  <td>{{ room.name || 'N/D' }}</td>
                  <td>{{ room.description || 'Nessuna descrizione' }}</td>
                  <td>
                    <span
                      :style="room.color ? { backgroundColor: room.color, padding: '5px', borderRadius: '3px', color: '#fff' } : {}"
                    >
                      {{ room.color || 'N/D' }}
                    </span>
                  </td>
                  <td>
                    <span v-if="!room.img">N/D</span>
                    <div v-else>
                      {{ room.img }}
                      <img
                        :src="room.img"
                        alt="Immagine Stanza"
                        style="max-width: 50px; max-height: 50px; margin-left: 10px; border: 1px solid #ddd;"
                      />
                    </div>
                  </td>
                  </tr>
              </tbody>
            </table>
          </div>

          <div v-else-if="!loadingStore.getters.isLoading">
            <p>Caricamento dati evento non riuscito o nessun record trovato.</p>
          </div>

        </div>
        <div class="col s1"></div>
      </div>
    </div>
     <div>
      </div>
  </div>
</template>

<script>
import loadingStore from '@/store/loading'
import useAuthStore from '@/store/authStore.js'
import apiService from '@/services/apiService.js'
import eventSetting from '@/store/eventSettings.js'

export default {
  name: 'RoomDetailsView',
  data () {
    return {
      loadingStore: loadingStore,
      roomData: []
    }
  },
  computed: {
    isAuth () {
      return useAuthStore.getters.isAuthenticated
    },
    fullEventData () {
      return eventSetting.getters.eventModel || {}
    },
    uidEvent () {
      return this.fullEventData.uid || null
    }
  },

  watch: {
    uidEvent: {
      immediate: true,
      handler (newUid) {
        if (newUid && this.roomData.length === 0) {
          this.loadingStore.commit('setLoading', true)
          this.loadRoomDetails()
        }
      }
    }
  },

  methods: {
    // **********************************************
    // NUOVO METODO: Navigazione alla rotta di creazione
    // **********************************************
    goToCreateRoom () {
      // Assicurati che la tua configurazione del router abbia una rotta definita come 'create-room'
      this.$router.push('/create-room')
    },
    // **********************************************

    async loadRoomDetails () {
      const token = await apiService.getClientCredentialsToken()

      if (!token) {
        this.$router.push('/error')
        this.loadingStore.commit('setLoading', false)
        return
      }

      const uid = this.uidEvent
      const url = process.env.VUE_APP_URL_EVENTS + '/table/list-room/' + uid

      try {
        const json = await apiService.sendRequestWithBearer('GET', url, token, null)

        if (Array.isArray(json)) {
          this.roomData = json
        } else {
          this.roomData = json ? [json] : []
        }
      } catch (error) {
        console.error('Errore durante il caricamento dei dettagli della stanza:', error)
        this.$router.push('/error')
      } finally {
        this.loadingStore.commit('setLoading', false)
      }
    }
  },

  async mounted () {
    if (!this.uidEvent) {
      this.loadingStore.commit('setLoading', true)
    }
  },

  created () {
    // Lasciamo vuoto
  }
}
</script>

<style scoped>
.content-container {
  padding: 20px;
  line-height: 1.6;
  color: #333;
}
.striped {
    border-collapse: collapse;
    width: 100%;
}
.striped th, .striped td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}
.striped tr:nth-child(even) {
    background-color: #f2f2f2;
}
.separator {
    margin: 15px 0;
    border: 0;
    border-top: 1px solid #eee;
}
</style>
